import React from 'react'
import { Nav } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { useSelector } from 'react-redux'


export default function SubMenuHabilities({ seccion, usertype, candidateId }) {
    const { t } = useTranslation()
    const {candidateStatus} = useSelector(state=>state.candidates)

    return (
        <Nav defaultActiveKey="/candidate/profile/competences" className="flex-column submenu">
            <Nav.Item>
                <Link
                    to={usertype === 'Superadmin' ? '/admin/candidate/competences/'+candidateId : '/candidate/profile/competences'}
                    className={`nav-link ${seccion === 'competences' ? 'active' : ''}${usertype === 'Superadmin' ? '' : (candidateStatus === 'completed' || parseFloat(candidateStatus) > 4 ? '' : 'disabled')}`}
                >
                    <img src="/images/menus/competences.svg" alt="Competencias" className='me-3'/>
                    {t('profile.candidate.competences')}
                </Link>
            </Nav.Item>
            <Nav.Item>
                <Link
                    to={usertype === 'Superadmin' ? '/admin/candidate/languages/'+candidateId : '/candidate/profile/languages'}
                    className={`nav-link ${seccion === 'languages' ? 'active' : ''}${usertype === 'Superadmin' ? '' : (candidateStatus === 'completed' || parseFloat(candidateStatus) > 4.1 ? '' : 'disabled')}`}
                >
                    <img src="/images/menus/languages.svg" alt="Idiomas" className='me-3'/>
                    {t('profile.candidate.languages')}
                </Link>
            </Nav.Item>
            <Nav.Item>
                <Link
                    to={usertype === 'Superadmin' ? '/admin/candidate/technologies/'+candidateId : '/candidate/profile/technologies'}
                    className={`nav-link ${seccion === 'technologies' ? 'active' : ''}${usertype === 'Superadmin' ? '' : (candidateStatus === 'completed' || parseFloat(candidateStatus) > 4.2 ? '' : 'disabled')}`}
                >
                    <img src="/images/menus/technologies.svg" alt="Tecnologías" className='me-3'/>
                    {t('profile.candidate.technologies')}
                </Link>
            </Nav.Item>
            <Nav.Item>
                <Link
                    to={usertype === 'Superadmin' ? '/admin/candidate/methodologies/'+candidateId : '/candidate/profile/methodologies'}
                    className={`nav-link ${seccion === 'methodologies' ? 'active' : ''}${usertype === 'Superadmin' ? '' : (candidateStatus === 'completed' || parseFloat(candidateStatus) > 4.3 ? '' : 'disabled')}`}
                >
                    <img src="/images/menus/methodologies.svg" alt="Metodologías" className='me-3'/>
                    {t('profile.candidate.methodologies')}
                </Link>
            </Nav.Item>
        </Nav>
    )
}